var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#ECEEF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.44 13.0996C24.63 13.0996 23.01 13.9796 22 15.3296C20.99 13.9796 19.37 13.0996 17.56 13.0996C14.49 13.0996 12 15.5996 12 18.6896C12 19.8796 12.19 20.9796 12.52 21.9996C14.1 26.9996 18.97 29.9896 21.38 30.8096C21.72 30.9296 22.28 30.9296 22.62 30.8096C25.03 29.9896 29.9 26.9996 31.48 21.9996C31.81 20.9796 32 19.8796 32 18.6896C32 15.5996 29.51 13.0996 26.44 13.0996Z",
    fill: "#5A82D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartDetail);
export default __webpack_public_path__ + "static/media/heart-detail.7d16fc0310bd28c6410a28410bf87d8b.svg";
export { ForwardRef as ReactComponent };